import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'
import { TefProductCodeCreateValidationSchema } from '../schemas/tefProductCode.schema';

interface UseCreateTefProductProps {
  provider?: string;
  onSuccess: (response: AxiosResponse) => void;
  onError: (error: ErrorResponse) => void;
}

export const useCreateTefProductCode = ({ provider, onSuccess, onError }: UseCreateTefProductProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['createTefProductCode'],
    mutationFn: async (form: TefProductCodeCreateValidationSchema) => {
      const payload = {
        tef_product_code: {
          code: form.code,
          product_id: form.product_id.value,
          provider,
        }
      }

      return privateAxios.post('/tef_product_codes', payload);
    },
    onSuccess,
    onError,
  });
}
